export default __webpack_public_path__ + "assets/images/04d51f78f888edaf60d8ab9dbae32154.png";